




















































import vue, {PropType} from 'vue';

type AvailabilitiesType = 'MORNING' | 'LUNCH_TIME' | 'AFTERNOON' | 'EVENING' | 'WEEKEND'

export const availabilities: AvailabilitiesType[] = [
  'MORNING',
  'LUNCH_TIME',
  'AFTERNOON',
  'EVENING',
  'WEEKEND',
];

interface PeriodProp {
  datesSelected?: string[];
  periodSelected?: AvailabilitiesType[];
}

interface PeriodItems {
  text: string;
  value: AvailabilitiesType;
}

interface ComponentData {
  datesSelected: string[];
  datePickerDisplay: boolean;
  periodItems: PeriodItems[];
}

export default vue.extend({
  name: 'AdvertCreationPeriodSelection',

  props: {
    period: {
      required: true,
      type: Object as PropType<PeriodProp>,
    },
  },

  data: (): ComponentData => ({
    datesSelected: [],
    datePickerDisplay: false,
    periodItems: [],
  }),

  computed: {
    dateDisplay: function (): string {
      if (this.period.datesSelected && this.period.datesSelected.length > 0) {
        const dates = this.period.datesSelected.map(date => new Date(date));
        return dates.length === 2
            ? `${dates[0].toLocaleDateString()} -> ${dates[1].toLocaleDateString()}`
            : `${dates[0].toLocaleDateString()}`;
      }
      return '';
    },
  },

  created() {
    this.datesSelected = this.period.datesSelected || [];
    this.periodItems = availabilities.map<PeriodItems>(av => ({
      text: this.$t(`advert.creation.fields.period.periodEnum.${av}`) as string,
      value: av,
    }));
  },

  methods: {
    isDateUpdate(isDate: boolean): void {
      this.$emit('update:period', {
        isDate,
        datesSelected: [],
      });
    },
    /**
     * Mise à jour des dates selectionnées dans l'annonce
     */
    onValidDatePicker(): void {
      this.$emit('update:period', {...this.period, datesSelected: this.datesSelected.sort()});
      this.datePickerDisplay = false;
    },
    updatePeriod(periodSelected: AvailabilitiesType): void {
      this.$emit('update:period', {...this.period, periodSelected});
    },
  },
});
